/*
 * @Author: ç¯çç§æ(Lucas Huang)
 * @Date: 2019-09-02 17:55:57
 * @LastEditors: ç¯çç§æ(Lucas Huang)
 * @LastEditTime: 2019-10-23 16:57:28
 * @QQ: 1055818239
 * @Version: v0.0.1
 */
import { addDays, differenceInMinutes, format, isValid, parseISO, subDays } from "date-fns";
import { Injectable } from "@angular/core";
import { MyDateConverter } from "./myDateConverter";

import { format as timeagoFmt, TDate } from './timeago/timeago';


export type FirstDayOfWeek = 'ä¸' | 'æ¥';

@Injectable({
    providedIn: "root",
})
export class DateTimeHelperService {
    private $D = null;

    constructor() {
        this.$D = new MyDateConverter();
    }

    relativeTime(date: TDate, locale: 'en'|'zh-CHS'|'zh-CHT' = 'zh-CHS') {
        if (date) {
            return timeagoFmt(date, locale);
        }
        return '';
    }

    addDays(date: Date, days: number) {
        return addDays(date, days);
    }

    subDays(date: Date, days: number) {
        return subDays(date, days);
    }

    differenceInMinutes(dateLeft: Date | number, dateRight: Date | number) {
        return differenceInMinutes(dateLeft, dateRight);
    }

    /**
     * @param value è¦è½¬æ¢æ ¼å¼çæ¥æ
     * @param fmt æ ¼å¼åå­ç¬¦ä¸²
     *
     * æ´å¤çæ ¼å¼åè¯·åè
     * [ç¹æç¹æ](https://date-fns.org/v1.30.1/docs/format)
     */
    formatTo(value: any, fmt: string = "yyyy-MM-dd") {
        if (!value) {
            return "";
        }

        if (typeof value === "string" && value.indexOf("0001") === 0) {
            return "";
        }

        if (value instanceof Date) {
            return format(value, fmt);
        }

        let _d: any = parseISO(value);

        if (_d == "Invalid Date") {
            _d = this.createDate(value) || new Date(value);
        }

        // const d = parseISO(value);
        if (isValid(_d)) {
            const d = parseISO(format(_d, "yyyy-MM-dd HH:mm:ss"));
            return format(d, fmt);
        } else {
            // console.error(`${value} è½¬æ¢ä¸ºDateæ¶å¤±è´¥ã`);
            if (fmt.indexOf("HH") === 0 || fmt.indexOf("hh") === 0) {
                // ä»ææ¶é´é¨å
                // æåæ¶é´
                const _time = value
                    .match(/\d*/g)
                    .filter((n) => n !== "")
                    .join(":");

                if (fmt === "HH" || fmt === "hh") {
                    fmt = fmt += ":mm";
                }

                // const fullDateTime = new Date('2022-11-25 ' + _time);
                const fullDateTime = parseISO("2022-11-25 " + _time);
                return format(fullDateTime, fmt);
            }
            return "";
        }
    }

    private createDate(val) {
        return this.$D.create(val);
    }

    // æ ¹æ®åæ°æ¥æè·åå·ä½æ¥æä¿¡æ¯
    private formatDate(date = new Date(), firstDayOfWeek: FirstDayOfWeek = 'ä¸') {
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();

        let weekDay = date.getDay();
        if (firstDayOfWeek === 'ä¸') {
            if (!weekDay) {
                weekDay = 6;
            } else {
                weekDay = weekDay - 1;
            }
        }

        let week = ["ä¸", "äº", "ä¸", "å", "äº", "å­", "æ¥"][weekDay];

        const dateInfo = {
            date: new Date(date),
            dateStr: `${year}-${month.toString().padStart(2, "0")}-${day
                .toString()
                .padStart(2, "0")}`,
            year,
            month,
            day,
            week,
            isToday: false,
        };

        const today = new Date();
        // å¤æ­æ¯å¦ä¸ºå½å¤©
        if (
            today.getFullYear() === year &&
            today.getMonth() + 1 === month &&
            today.getDate() === day
        ) {
            dateInfo["isToday"] = true;
        }
        return dateInfo;
    }

    // æ ¹æ®åºåæ¥æï¼è·åé¿åº¦ä¸ºdayLenthçæ¥ææ°ç»
    private setDate(date = new Date(), step = 7, firstDayOfWeek: FirstDayOfWeek = 'ä¸') {
        let weekData = [];
        const week = date.getDay() - 1;


        let _rangeDays = week * -1; // ä»¥å¨ä¸ä¸ºç¬¬1å¤©

        if (firstDayOfWeek === 'æ¥') {
            _rangeDays = _rangeDays - 1;
        }
        date = this.getDateByDate(date, _rangeDays); // ä»¥å¨æ¥ä¸ºç¬¬1å¤©æ¶ -1
        for (let i = 0; i < step; i++) {
            weekData.push(
                this.formatDate(i == 0 ? date : this.getDateByDate(date, 1), firstDayOfWeek)
            );
        }
        return weekData;
    }

    // æ ¹æ®åºåæ¥æè·åååæå¤©çæ¥æå¯¹è±¡
    private getDateByDate(date = new Date(), range = 0) {
        date.setDate(date.getDate() + range);
        return date;
    }

    /* 
    è·åä»¥baselineDateæå¨å¨çä¸å¨ãåä¸å¨ãä¸ä¸å¨çæ¥æåææä¿¡æ¯(åæ¢å¨æä¹å¯éè¿åæ°dayLenthèªè¡è®¾ç½®)
    baselineDate: è®¾ç½®çåºåæ¥æ(è¿åçæ¥æåè¡¨çç¬¬ä¸ä¸ªæ¥æ)
    range: ä»¥ baselineDate ä¸ºåºåæ¥æçååå¤©æ°èå´(å¦åºåæ¥æçrangeä¸º0ï¼éè¦è¿åå7å¤©æ¥æï¼årangeä¸º-7ï¼å7å¤©årangeä¸º7)
    step: éè¦è·åçæ¥æä¿¡æ¯å¨æå¤©æ°ï¼é»è®¤è·åbaselineDateæå¨å¨çä¸å¨æ¥æä¿¡æ¯
    firstDayOfWeek: æ¯å¨ç¬¬ä¸å¤© æ¯ å¨ä¸ï¼è¿æ¯å¨æ¥ï¼é»è®¤ä¸º å¨ä¸
   */
    getWeekDate({ baselineDate = new Date(), range = 0, step = 7 }, firstDayOfWeek: FirstDayOfWeek = 'ä¸') {
        return this.setDate(this.getDateByDate(baselineDate, range), step, firstDayOfWeek);
    }

    /** æ ¹æ®å½åæ¥æï¼è·åå½åæ¯æå¨å¹´çç¬¬å å¨ */
    getYearWeek(year, month, day) {//aä¸ºå¹´ bä¸ºæ cä¸ºæ¥
        /*  
        date1æ¯å½åæ¥æ  
        date2æ¯å½å¹´ç¬¬ä¸å¤©  
        dæ¯å½åæ¥ææ¯ä»å¹´ç¬¬å¤å°å¤©  
        ç¨d + å½åå¹´çç¬¬ä¸å¤©çå¨å·®è·çåå¨é¤ä»¥7å°±æ¯æ¬å¹´ç¬¬å å¨  
        */
        var date1 = new Date(year, parseInt(month) - 1, day),
            date2 = new Date(year, 0, 1),
            d = Math.round((date1.valueOf() - date2.valueOf()) / 86400000);
        return Math.ceil((d + ((date2.getDay() + 1) - 1)) / 7);
    }

    getMonthWeek(year, month, day) {
        /**
        * a = d = å½åæ¥æ
        * b = 6 - w = å½åå¨çè¿æå å¤©è¿å®(ä¸ç®ä»å¤©)
        * a + b çåå¨é¤ä»¥7 å°±æ¯å½å¤©æ¯å½åæä»½çç¬¬å å¨
        */
        var date = new Date(year, parseInt(month) - 1, day),
            w = date.getDay(),
            d = date.getDate();
        if (w == 0) {
            w = 7;
        }
        var config = {
            getMonth: date.getMonth() + 1,
            getYear: date.getFullYear(),
            getWeek: Math.ceil((d + 6 - w) / 7),
        }
        return config;
    }


    getNowWeekTime(date: Date, firstDayOfWeek: FirstDayOfWeek) {
        date.setDate(date.getDate() - ((date.getDay() + 6) % 7));
        const begin = {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
        };
        date.setDate(date.getDate() + 6);
        const end = {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate()
        };

        if (firstDayOfWeek === 'ä¸') {
            return { begin, end };
        } else {
            if (date.getDay() != 0) {
                date.setDate(date.getDate() - date.getDay());
            }

            const _begin = {
                year: date.getFullYear(),
                month: date.getMonth() + 1,
                day: date.getDate()
            };

            date.setDate(date.getDate() + 6 - date.getDay());
            const _end = {
                year: date.getFullYear(),
                month: date.getMonth() + 1,
                day: date.getDate()
            }

            return {
                begin: _begin,
                end: _end
            }
        }
    }
}
